<div class="modal-header" id="copy-checklist-signature-modal-title">
    <h3 class="modal-title" id="modal-title" translate="F4M_PARTICIPANTS_TRAINER_SIGNATURE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <fieldset [formGroup]="signatureForm">
        <div class="row mb-3">
            <span class="col-sm-2 col-12 text-start col-form-label">{{ (employeeSignature$ | async)?.label }}</span>
            <div class="col-sm-auto col-12">
                <canvas
                    #signatureCanvas
                    class="cse-signature-canvas signature-canvas"
                    [ngClass]="{ 'ng-invalid': signaturePad && signaturePad.isEmpty && firstNameControl.enabled }"
                ></canvas>
            </div>
            <div class="col-sm-2 col-12">
                <button
                    type="button"
                    class="btn btn-secondary btn-lg mt-2 mt-md-0"
                    (click)="clearSignature()"
                    translate="F4M_SUMMARY_MODAL_CLEAR_LABEL"
                ></button>
            </div>
        </div>
        <div class="row mb-3">
            <label
                class="col-sm-2 col-12 col-form-label text-start"
                for="{{ (employeeSignature$ | async)?.nameXmlId }}-firstName"
                >First Name:</label
            >
            <div class="col-sm-10 col-12">
                <input
                    type="text"
                    class="form-control input-md name-input"
                    id="{{ (employeeSignature$ | async)?.nameXmlId }}-firstName"
                    [formControl]="firstNameControl"
                />
            </div>
        </div>
        <div class="row mb-3">
            <label
                class="col-sm-2 col-12 col-form-label text-start"
                for="{{ (employeeSignature$ | async)?.nameXmlId }}-lastName"
                >Last Name:</label
            >
            <div class="col-sm-10 col-12">
                <input
                    type="text"
                    class="form-control input-md name-input"
                    id="{{ (employeeSignature$ | async)?.nameXmlId }}-lastName"
                    [formControl]="lastNameControl"
                />
            </div>
        </div>
    </fieldset>
</div>
<div class="modal-footer">
    <button
        class="btn btn-primary"
        [disabled]="firstNameControl.invalid || lastNameControl.invalid || !signaturePad || signaturePad?.isEmpty"
        (click)="createChecklists()"
        translate="F4M_PARTICIPANTS_COPY_CHECKLIST"
    ></button>
</div>
